import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决多次点当前路由的时候报错
const originalPush = Router.prototype.push
Router.prototype.replace  = function replace (location) {
    return originalPush.call(this, location).catch(err => err)
}

//加载路由
const router = new Router({
	//mode: 'history'
});

//添加CRO路由
import url from './url.js'
router.addRoutes(url.menu);

export default router